import { render, staticRenderFns } from "./ListNewMemberComponent.vue?vue&type=template&id=0deb0842&scoped=true&"
import script from "./ListNewMemberComponent.vue?vue&type=script&lang=js&"
export * from "./ListNewMemberComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListNewMemberComponent.vue?vue&type=style&index=0&id=0deb0842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb0842",
  null
  
)

export default component.exports